import { updateItemInCollection } from "directus/src/operations";
import { COLLECTION } from "../../constants";

export async function updateDeliverable({ item, deliverableId }) {
  try {
    return await updateItemInCollection(COLLECTION, deliverableId, item);
  } catch (error) {
    console.log(error);
    throw error;
  }
}
